import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query";
import { captureException } from "./sentry";

// Skip reporting routine auth failures (handled/expected) to avoid noise.
function isIgnorableApiError(error: unknown): boolean {
  const status = (error as { status?: number })?.status;
  return status === 401 || status === 403;
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (isIgnorableApiError(error)) return;
      captureException(error, {
        tags: { source: "react-query", kind: "query" },
        extra: { queryKey: query.queryKey },
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      if (isIgnorableApiError(error)) return;
      captureException(error, {
        tags: { source: "react-query", kind: "mutation" },
        extra: { mutationKey: mutation.options.mutationKey },
      });
    },
  }),
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30000,
    },
  },
});
